import React, { FC } from 'react';

import { EvSkeleton } from '@evinced-private/ui-common';

import { TableSkeleton } from 'src/common/components/skeletons/table-skeleton/TableSkeleton';

import { AccessibilitySummarySkeleton } from '../accessibility-summary-skeleton/AccessibilitySummarySkeleton';
import { ChartSkeleton } from '../chart-skeleton/ChartSkeleton';

import './DashboardSkeleton.scss';

interface DashboardSkeletonProps {
	isAnimated?: boolean;
}

export const DashboardSkeleton: FC<DashboardSkeletonProps> = ({ isAnimated = true }) => {
	const animationSpeed = isAnimated ? undefined : 0;

	return (
		<div className="dashboard-skeleton">
			<div className="skeleton-top-section">
				<EvSkeleton height="40px" width="200px" animationSpeed={animationSpeed} />
			</div>

			<div className="skeleton-title">
				<EvSkeleton height="40px" width="250px" animationSpeed={animationSpeed} />
			</div>
			<div className="skeleton-filters-section">
				<div className="skeleton-filters-row">
					<EvSkeleton height="60px" width="240px" animationSpeed={animationSpeed} />
					<EvSkeleton height="60px" width="180px" animationSpeed={animationSpeed} />
					<EvSkeleton height="40px" width="70px" animationSpeed={animationSpeed} />
					<EvSkeleton height="40px" width="70px" animationSpeed={animationSpeed} />
				</div>
			</div>
			<AccessibilitySummarySkeleton animationSpeed={animationSpeed} />
			<div className="skeleton-section-title">
				<EvSkeleton height="36px" width="300px" animationSpeed={animationSpeed} />
			</div>
			<div className="skeleton-charts-row">
				<ChartSkeleton animationSpeed={animationSpeed} />
				<ChartSkeleton animationSpeed={animationSpeed} />
			</div>
			<div className="skeleton-section-title">
				<EvSkeleton height="36px" width="300px" animationSpeed={animationSpeed} />
			</div>

			<TableSkeleton columns={6} rowCount={7} />
		</div>
	);
};
